import { ThemeConfig, theme } from "antd";
export const ATSTheme: ThemeConfig = {
  algorithm: theme.defaultAlgorithm,
  token: {
    colorPrimary: "#25245E",
    wireframe: false,
    colorTextBase: "#66697c",
    colorBgBase: "#f8f8fe",
    colorLink: "#25245E",
    fontSize: 16,
    borderRadius: 8,
  },

  components: {
    Button: {
      colorPrimary: "#25245E",
      controlHeight: 40,
      paddingInline: 24,
      paddingBlock: 16,
    },
    Card: {
      colorBgBase: "#f8f8fe",
    },
    Input: {
      colorBgBase: "#f8f8fe",
      // paddingInline: 16,
      // paddingBlock: 12,
    },
    Select: {
      colorBgBase: "#f8f8fe",
      // paddingContentHorizontal: 16,
      // paddingContentVertical: 12,
    },
    Table: {
      colorBgBase: "#f8f8fe",
    },
    Tag: {
      colorBgBase: "#f8f8fe",
    },
    Tabs: {
      colorBgBase: "#f8f8fe",
    },
    Typography: {
      colorTextBase: "#66697c",
    },
    Modal: {
      colorBgBase: "#f8f8fe",
    },
    Pagination: {
      colorBgBase: "#f8f8fe",
    },
    Popover: {
      colorBgBase: "#f8f8fe",
    },
    Radio: {
      colorBgBase: "#f8f8fe",
    },
    Switch: {
      colorBgBase: "#f8f8fe",
    },
    Tooltip: {
      colorBgSpotlight: "#66697C",
    },
  },
};
